import React from "react";

const Contact = () => {
    return(
        <>
        <div id="get-quote" className="get-quote-bg">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <div className="mb-30px">
            <div className="section-heading theme-text-center">
              <h1 className="head-back-light">Contact</h1>
              <h2 className="head-after head-after-white">Send us a message</h2>
            </div>
          </div>
        </div>
        <div className="col-lg-12">
          <div className="get-quote-item">
            <form
              id="get_quote_form"
              className="col-form"
              action=""
              method="post"
            >
              <div className="row">
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="first_name"
                      placeholder="First Name"
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="last_name"
                      placeholder="Last Name"
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="phone"
                      placeholder="Phone"
                    />
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="Email"
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group">
                    <div className="select-scroll">
                      <select className="form-control" name="subject">
                        <option value="">Service</option>
                        <option value="Food">Food</option>
                        <option value="Event Planning">Event Planning</option>
                        <option value="Auto parts">Auto parts</option>
                        <option value="Insurance">Insurance</option>
                        <option value="Logistics">Logistics</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-lg-12">
                  <div className="form-group">
                    <textarea
                      className="form-control"
                      name="message"
                      rows={4}
                      placeholder="Messages"
                      defaultValue={""}
                    />
                  </div>
                </div>
                <div className="col-lg-12">
                  <button
                    type="submit"
                    className="btn theme-btn-default btn-icon"
                  >
                    <span>Submit</span>
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
        </>
    )
}

export default Contact;